<div id="verify-identity-container">
  <div *ngIf="!loading" class="self-tour-step-header">
    <div class="text-xl font-denim-semibold">
      VERIFY YOUR IDENTITY
    </div>
  </div>
  <div *ngIf="loading" class="self-tour-step-header">
    <div class="text-xl font-denim-semibold">
      VERIFYING YOUR IDENTITY
    </div>
  </div>
  <div *ngIf="!loading" id="upload-selfie-file-container">
    <div *ngIf="selfieFile === null" id="upload-selfie-placehold-cont">
      <p>To verify your identity, please take a selfie by clicking the button below.</p>
    </div>
    <div *ngIf="selfieFile !== null" id="upload-selfie-image-cont" class="justify-self-center sm:justify-self-start" (click)="takePhoto()">
      <img id="uploadedSelfieImage" src="#"/>
    </div>
    <input type="file" name="selfieFile" id="selfieFile"accept="image/*" capture="user" (change)="readUpload($event)" />
  </div>
  <div *ngIf="loading">
    <div class="flex justify-center"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner></div>
  </div>
  <div *ngIf="!loading" class="flex justify-end">
    <div class="w-full sm:w-1/3">
      <div class="grid grid-cols-1">
        <button *ngIf="selfieFile === null" mat-flat-button color="accent" (click)="takePhoto()">TAKE PHOTO</button>
        <button *ngIf="selfieFile !== null" mat-flat-button color="accent" (click)="verifyLocation()">USE PHOTO</button>
      </div>
    </div>
  </div>
</div>
